const footerLinks = {
  '热门分类': ['日剧美剧', '国产电视剧', '华语电影', '欧美大片', '动漫番剧', '综艺娱乐'],
  '帮助中心': ['常见问题', '播放帮助', '意见反馈', '侵权申诉'],
  '关于我们': ['平台介绍', '内容来源', '更新计划'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                樱花TV
              </span>
              <p className="mt-3 text-sm leading-relaxed text-background-400">
                樱花TV提供日剧美剧、国产电视剧、华语电影、欧美大片免费在线观看，高清全集不缓冲无需付费，零成本享受海量影视。
              </p>
            </div>
            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-semibold text-background-50 mb-3">
                  {title}
                </h4>
                <ul className="space-y-2">
                  {links.map((link) => (
                    <li key={link}>
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50">
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-sm text-background-600">暂无合作伙伴信息</p>
          </div>

          <div className="mt-8 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-600">
              &copy; {new Date().getFullYear()} 樱花TV 版权所有
            </p>
            <p className="text-xs text-background-600">
              本站内容仅供交流学习，不存储任何视频文件
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}